/**
 * @file Defines a mapping from MIME types to string identifiers for file icons.
 * This map is used to abstract the relationship between a file's type and its visual representation identifier, which is then resolved to an actual icon asset in another module.
 */
/**
 * An object mapping standard MIME type strings to corresponding icon identifier strings.
 * Includes a 'default' key for unrecognized MIME types.
 *
 * The values (e.g., 'pdfIcon') are expected to match keys in the `icons` object within the `filetype-icons/index.ts` module.
 *
 * @type {Record<string, string>}
 */
const mimeToIcon = {
    'default': 'defaultIcon',
    'text/csv': 'csvIcon',
    'application/msword': 'docIcon',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docxIcon',
    'application/vnd.ms-excel': 'xlsIcon',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsIcon',
    'application/vnd.ms-powerpoint': 'pptIcon',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptIcon',
    'application/pdf': 'pdfIcon',
    'image/jpeg': 'jpgIcon',
    'image/png': 'pngIcon',
    'image/gif': 'gifIcon',
    'image/bmp': 'bmpIcon',
    'image/tiff': 'tiffIcon',
    'image/vnd.adobe.photoshop': 'psdIcon',
    'image/svg+xml': 'svgIcon',
    'text/plain': 'txtIcon',
    'text/html': 'htmlIcon',
    'application/x-msdos-program': 'exeIcon',
    'application/java-archive': 'javaIcon',
    'application/xml': 'xmlIcon',
    'text/xml': 'xmlIcon',
    'application/zip': 'zipIcon',
    'application/x-rar-compressed': 'rarIcon',
    'application/json': 'jsonIcon',
    'audio/mpeg': 'mp3Icon',
    'audio/wav': 'wavIcon',
    'audio/wave': 'wavIcon',
    'audio/x-ms-wma': 'wmaIcon',
    'video/x-msvideo': 'aviIcon',
    'application/mp4': 'mp4Icon',
    'video/mp4': 'mp4Icon',
    'video/mpeg': 'mpegIcon',
    'video/quicktime': 'movIcon',
    'application/vnd.ms-access': 'mdbIcon',
    'application/x-msaccess': 'mdbIcon',
    'application/vnd.ms-publisher': 'pubIcon',
    'application/x-mspublisher': 'pubIcon',
    'application/x-dwg': 'dwgIcon',
    'image/vnd.dwg': 'dwgIcon',
    'application/x-iso9660-image': 'isoIcon',
    'audio/midi': 'midIcon',
    'video/x-flv': 'flvIcon',
    'application/rss+xml': 'rssIcon',
    'application/rtf': 'docIcon',
    'application/vnd.adobe.illustrator': 'aiIcon',
    'application/postscript': 'aiIcon',
    'application/vnd.rar': 'rarIcon',
    'video/x-ms-wmv': 'wmaIcon',
    'application/vnd.oasis.opendocument.text': 'docxIcon',
    'application/vnd.oasis.opendocument.spreadsheet': 'xlsIcon',
    'application/vnd.oasis.opendocument.presentation': 'pptIcon',
    'application/x-msdownload': 'dllIcon',
    'application/vnd.microsoft.portable-executable': 'dllIcon'
};
export default mimeToIcon;
